import GalleriesList from "./GalleriesList";
export default GalleriesList;
